import React, { useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import AppContainer from 'components/AppContainer';
import _ClassNames from 'classnames';
import SearchTopics from './SearchTopics';
import { getHelpMeValues } from './utils';
import FilterContext from './FilterContext';
import SearchTypes from './SearchTypes';

const useStyles = makeStyles(theme => ({
  root: {
    height: 105,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: props => props.bg || 'rgba(1, 97, 155, 0.9)',
    alignItems: 'center',
    filter: props => (props.bg ? 'brightness(0.96)' : 'brightness(1)'),
    [theme.breakpoints.down('600')]: {
      height: '255px !important',
    },
  },
  desktopWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    [theme.breakpoints.down('770')]: {
      '& p': {
        fontSize: 17,
      },
      '& div': {
        fontSize: 17,
      },
    },
  },
  label: {
    color: props => props.textColor,
  },
  inlineLabel: {
    display: 'inline-block',
    [theme.breakpoints.down('991')]: {
      display: 'none',
    },
  },
  button: {
    color: theme.palette.primary.main,
    boxShadow: 'none',
    width: 163,
    height: 54,
    backgroundColor: '#fff !important',
    [theme.breakpoints.down('900')]: {
      width: 100,
    },
    [theme.breakpoints.down('600')]: {
      width: 163,
    },
    borderRadius: 27,
    ...theme.typography.button,
  },
}));

function DesktopScroll() {
  const {
    changeFilter,
    mediaTypes,
    selectedMediaType,
    go,
    selectedTopicSlug,
    fontColor,
    bg,
  } = useContext(FilterContext);
  const introColor = fontColor;
  const textColor = introColor ? `#${introColor}` : '#fff';
  const classes = useStyles({ textColor, bg });
  const helpMeValues = getHelpMeValues();
  return (
    <Grid container direction="row" className={classes.root}>
      <AppContainer noPadding>
        <Grid item xs={12} className={classes.desktopWrapper}>
          <Typography
            align="right"
            className={_ClassNames(classes.label, classes.inlineLabel)}
          >
            {helpMeValues[0]}
          </Typography>
          <SearchTopics />
          <Typography
            align="right"
            className={_ClassNames(classes.label, classes.inlineLabel)}
          >
            {helpMeValues[1]}
          </Typography>
          <SearchTypes
            data={mediaTypes}
            value={selectedMediaType}
            changeHandler={changeFilter}
          />
          <Button
            variant="contained"
            className={classes.button}
            onClick={go}
            disabled={!selectedTopicSlug || !selectedMediaType}
          >
            GO
          </Button>
        </Grid>
      </AppContainer>
    </Grid>
  );
}

export default DesktopScroll;
